/*
export const primaryColor = '#083DA6'; // 'rgb(25, 118, 210)';
export const secundaryColor = '#034AA6'; // 'rgb(255, 165, 0)';
export const primaryDarkColor = '#1A1A1D';

export const successColor = 'rgb(1, 246, 99)';
export const infoColor = '#0197F6';
export const errorColor = 'rgb(242, 74, 41)';
export const warningColor = '#F2AF29';
*/
export const primaryColor = '#454259'; // 'rgb(25, 118, 210)';
export const secundaryColor = '#4A4873'; // 'rgb(255, 165, 0)';
export const primaryDarkColor = '#1A1A1D';

export const successColor = 'rgb(1, 246, 99)';
export const infoColor = '#0197F6';
export const errorColor = 'rgb(242, 74, 41)';
export const warningColor = '#F2AF29';

export const cardColor1 = '#FF6347';
export const cardColor2 = '#1E90FF';
export const cardColor3 = '#32CD32';
export const cardColor4 = '#8A2BE2';
export const cardColor5 = '#fa6997';

export const TotalColor = '#fffa4f';
export const SubTotalColor = '#76b58d';
